import clsx from 'clsx';
type Option = {
  value: string;
  label: string;
};

type OptionsDropdownProps = {
  options: Option[];
  onOptionChange: (value: string) => void;
  onClose: () => void;
};

export default function OptionsDropdown({ options, onOptionChange, onClose }: OptionsDropdownProps) {
  const handleOptionClick = (value: string) => {
    onOptionChange(value);
    onClose();
  };

  return (
    <div className="absolute top-full left-0 w-40 bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden z-[1000] mt-1">
      {options.map((option, index) => (
        <div
          key={option.value}
          className={clsx(
            'px-4 py-3 text-slate-600 text-sm font-medium cursor-pointer transition-all duration-200 ease-in-out hover:bg-slate-50 hover:text-blue-800 font-avenir',
            index < options.length - 1 && 'border-b border-gray-100'
          )}
          onClick={() => handleOptionClick(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
}
